import {
    GenericSideMenuItemComponent
} from "../../../../../components/side-menu-rework/side-menu-items/generic-side-menu-item.component";
import styled from "styled-components";


export const MichiganSportSideMenuItemComponent = styled(GenericSideMenuItemComponent)`
    border: 2px solid rgba(112, 115, 114, 0.5) !important;
    border-radius: 10px;
    margin: 0;
    overflow: hidden;
`;